import { apiRequest } from "util/services";

/** Pivony MCP status, limits and this month's usage for the user's organization. */
export const fetchMcpProStatus = () =>
  apiRequest("mcp/pro/status", "GET", null, true);

/** AI assistants connected with the user's Pivony account (the organization's, for its account holder). */
export const fetchMcpConnections = () =>
  apiRequest("mcp/connections", "GET", null, true);

/** Disconnect an AI assistant: its access ends at once. user_id only for a colleague's connection. */
export const revokeMcpConnection = (clientId, userId) =>
  apiRequest("mcp/connections/revoke", "POST", { client_id: clientId, ...(userId ? { user_id: userId } : {}) }, true);

/** What the consent page shows for an OAuth authorize request (client, redirect host, Pivony MCP). */
export const fetchOauthConsentInfo = (params) =>
  apiRequest(`oauth/consent-info?${new URLSearchParams(params).toString()}`, "GET", null, true);

/** Approve the request; the answer carries the redirect_url back to the client. */
export const approveOauthRequest = (params) =>
  apiRequest("oauth/approve", "POST", params, true);
